import { staticContentService } from '~/api/local-api/localService';
import { ApiUrl } from '~/core/enums';
import { PredefinedShape } from '~/core/models';

export type PredefinedShapesParams = void;

const predefinedShapesService = staticContentService.injectEndpoints({
  endpoints: (builder) => ({
    fetchPredefinedShapes: builder.query<
      PredefinedShape[],
      PredefinedShapesParams
    >({
      query: () => ({
        url: ApiUrl.PREDEFINED_SHAPES,
        method: 'GET',
      }),
    }),
  }),
});

export const { useFetchPredefinedShapesQuery } = predefinedShapesService;
